/** '' → null, otherwise the number — optional amounts must stay null, never become 0. */
export const num = (v: string): number | null => (v.trim() === '' ? null : Number(v));
export const str = (v: number | string | null | undefined): string => (v === null || v === undefined ? '' : String(v));
export const isBadNumber = (v: string) => v.trim() !== '' && Number.isNaN(Number(v));
